/**
 * Logo propio de cada cuenta de llamadas: Ooma (rojo), USCaller (cuadro morado con teléfono, número de puesto en una esquina) o la ruta
 * propia de Commandix (isotipo). `size` (px) lo encoge para el uso "mini" junto a un número (components/LogosNumero.jsx); sin `size` se
 * queda con el tamaño grande de siempre (lista de cuentas / ventanita «¿Por dónde llamar?»). `title` = tooltip nativo del navegador.
 */
export default function LogoCuenta({ cuenta, chico = false, size = null, title = null }) {
  const style = size ? { width: size, height: size, fontSize: Math.max(8, Math.round(size * 0.28)) } : undefined;
  if (cuenta.app === "commandix") {
    return (
      <div className="nt-lg2 lg cx" data-testid="nt-logo-commandix" style={style} title={title || undefined}>
        <img src="/brand/commandix-isotipo-transparente.png" alt="Commandix" />
      </div>
    );
  }
  if (cuenta.app === "ooma") {
    return (
      <div className={`nt-lg2 lg${chico ? " chico" : ""}`} data-testid="nt-logo-ooma" style={style} title={title || undefined}>
        <img src="/brand/logo_ooma_rojo.jpg" alt="Ooma" />
      </div>
    );
  }
  return (
    <div className={`nt-lg2 lg us${chico ? " chico" : ""}`} data-testid="nt-logo-uscaller" style={style} title={title || undefined}>
      <img src="/brand/logo_usecaller.svg" alt="USCaller" /><b>{cuenta.slot}</b>
    </div>
  );
}
